export function formatBytes(bytes: number | string, decimals = 2) {
  const bytesNumber = Number(bytes);

  if (!bytesNumber) {
    return '0 Bytes' as const;
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [
    'Bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB',
  ] as const;

  const i = Math.floor(Math.log(bytesNumber) / Math.log(k));

  return `${parseFloat((bytesNumber / Math.pow(k, i)).toFixed(dm))} ${
    sizes[i]
  }` as const;
}
